/* Customer portal at / — screen state machine + app shell.
 *
 * esbuild entry (auto-discovered by Scripts/build_js.py). 2026-08 port of the
 * legacy in-browser-babel templates/ELCAPP.html to the same pipeline as the
 * admin islands: JSX compiled at build time, production React UMD globals
 * loaded by templates/elcapp_portal.html.
 */
import { useState, useEffect, Nav } from './portal/common.js';
import { Landing } from './portal/landing.js';
import { QuoteForm } from './portal/quoteform.js';
import { QuoteResults } from './portal/results.js';
import { MyQuotes } from './portal/myquotes.js';
import { BookingForm, OrderConfirmation } from './portal/booking.js';
import { Login } from './portal/auth.js';

const App = () => {
  const [screen, setScreen] = useState('landing');
  const [fd, setFd] = useState({});
  const [qr, setQr] = useState(null);
  const [sq, setSq] = useState(null);
  const [od, setOd] = useState(null);
  const [user, setUser] = useState({ loggedIn: false, company: '', code: '', isInternal: false, bookingEnabled: false });
  const [userLoaded, setUserLoaded] = useState(false);
  const [postLoginAction, setPostLoginAction] = useState(null);

  useEffect(() => {
    fetch('/api/elcapp/me')
      .then(r => r.json())
      .then(d => {
        if (d.loggedIn) setUser({ loggedIn: true, company: d.company, code: d.code, isInternal: d.isInternal || false, bookingEnabled: !!d.bookingEnabled });
        setUserLoaded(true);
      })
      .catch(() => setUserLoaded(true));
  }, []);

  const handleLogout = async () => {
    await fetch('/api/elcapp/portal-logout', { method: 'POST' }).catch(() => {});
    setUser({ loggedIn: false, company: '', code: '', isInternal: false, bookingEnabled: false });
    setScreen('landing');
  };

  const screens = {
    landing:      <Landing setScreen={setScreen} setFD={setFd} user={user} />,
    quote:        <QuoteForm setScreen={setScreen} setQR={setQr} fd={fd} />,
    results:      <QuoteResults setScreen={setScreen} quoteData={qr} setSQ={setSq} user={user} userLoaded={userLoaded} setPostLoginAction={setPostLoginAction} />,
    myquotes:     <MyQuotes setScreen={setScreen} setSQ={setSq} user={user} />,
    booking:      <BookingForm setScreen={setScreen} setOD={setOd} sq={sq} setSQ={setSq} />,
    confirmation: <OrderConfirmation setScreen={setScreen} od={od} />,
    login:        <Login setScreen={setScreen} setUser={setUser} postLoginAction={postLoginAction} setPostLoginAction={setPostLoginAction} />,
  };

  return <div style={{ background: '#f8fafc', minHeight: '100vh', color: '#0f172a', fontFamily: "'Barlow',sans-serif" }}>
    <Nav screen={screen} setScreen={setScreen} user={user} onLogout={handleLogout} />
    <div className="fadein" key={screen}>{screens[screen] || screens.landing}</div>
  </div>;
};
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
